import { industryFromVertical } from "@crm-src/lib/industries";

import type { SalesAddToCrmRequest, SalesOrgLeadDetail } from "@xop/dashboard-shared";

import { contactInfo, toCrmContacts } from "./contacts.js";

/**
 * Build the add-to-CRM payload from a full lead detail — the single source of
 * truth shared by BOTH the lead-detail "Qualify for CRM" button and the Sales
 * leads-list row action, so the two can never drift.
 *
 * Carries the agent's identified `vertical` across as the CRM prospect's
 * industry (via `industryFromVertical`) and EVERY contact the agent found —
 * all named buyers AND any generic org inbox (info@/sales@) — via
 * `toCrmContacts`, so a multi-buyer lead lands in the CRM with all of them (not
 * just the first). `exactOptionalPropertyTypes` forbids passing `undefined` to
 * an optional field, so every optional is a conditional spread.
 */
export function buildAddToCrmPayload(lead: SalesOrgLeadDetail): SalesAddToCrmRequest {
  const info = contactInfo(lead);
  const contacts = toCrmContacts(info);
  const industry = industryFromVertical(lead.vertical);
  return {
    company_name: lead.name,
    ...(lead.domain ? { website: lead.domain } : {}),
    ...(industry ? { industry } : {}),
    ...(contacts.length ? { contacts } : {}),
    notes: `Qualified for the CRM from the XOP Sales Agent.\n\n${lead.agent_summary ?? ""}`
      .trim()
      .slice(0, 4000),
  };
}
